import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

export const LandscapeOverlay = () => {
  const { t } = useTranslation();
  const [showOverlay, setShowOverlay] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      // Only show on mobile devices in portrait mode
      const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
      const isPortrait = window.innerHeight > window.innerWidth;
      setShowOverlay(isMobile && isPortrait);
    };

    // Try to lock orientation on supported browsers
    const lockOrientation = async () => {
      try {
        if (screen.orientation && 'lock' in screen.orientation) {
          await (screen.orientation as any).lock('landscape');
        }
      } catch (e) {
        // Orientation lock not supported or failed - that's okay, we'll show the overlay
      }
    };

    checkOrientation();
    lockOrientation();

    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', checkOrientation);

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!showOverlay) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/95 flex flex-col items-center justify-center text-white">
      <div className="animate-pulse mb-8">
        <svg
          width="80"
          height="80"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.5"
          className="text-cyan-400"
        >
          {/* Phone rotating icon */}
          <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
          <path d="M12 18h.01" />
        </svg>
      </div>
      <div className="text-center px-8">
        <h2 className="text-2xl font-bold mb-2 font-['Orbitron']">{t('landscape.title')}</h2>
        <p className="text-gray-400 font-['Rajdhani']">
          {t('landscape.message')}
        </p>
      </div>
      <div className="mt-8 flex items-center gap-4 text-cyan-400">
        <div className="w-12 h-8 border-2 border-current rounded-md relative">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-1 bg-current rounded-full" />
        </div>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          className="animate-bounce"
        >
          <path d="M5 12h14M12 5l7 7-7 7" />
        </svg>
        <div className="w-16 h-10 border-2 border-current rounded-md relative">
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-1 h-1 bg-current rounded-full" />
        </div>
      </div>
    </div>
  );
};
